


































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';
import latinize from 'latinize';
import 'intro.js/introjs.css';
import introJs from 'intro.js';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies, { expire: -1 });

import omegaup_Markdown from '../Markdown.vue';
import course_CardPublic from './CardPublic.vue';
import course_CardEnrolled from './CardEnrolled.vue';
import course_CardFinished from './CardFinished.vue';

export enum Tab {
  Enrolled = 'enrolled',
  Public = 'public',
  Finished = 'finished',
}

export enum Level {
  All = 'all',
  Introductory = 'introductory',
  Intermediate = 'intermediate',
  Advanced = 'advanced',
}

@Component({
  components: {
    'omegaup-course-card-public': course_CardPublic,
    'omegaup-course-card-enrolled': course_CardEnrolled,
    'omegaup-course-card-finished': course_CardFinished,
    'omegaup-markdown': omegaup_Markdown,
  },
})
export default class CourseTabs extends Vue {
  @Prop() courses!: {
    enrolled: types.CourseCardEnrolled[];
    public: types.CourseCardPublic[];
    finished: types.CourseCardFinished[];
  };
  @Prop({ default: false }) loggedIn!: boolean;
  @Prop({ default: Tab.Public }) selectedTab!: Tab;
  @Prop() hasVisitedSection!: boolean;

  T = T;
  ui = ui;
  Tab = Tab;
  Level = Level;
  currentSelectedTab = this.selectedTab;
  searchText = '';
  levelFilter = Level.All;

  mounted() {
    const title = T.joinCourseInteractiveGuideTitle;
    if (!this.hasVisitedSection) {
      introJs()
        .setOptions({
          nextLabel: T.interactiveGuideNextButton,
          prevLabel: T.interactiveGuidePreviousButton,
          doneLabel: T.interactiveGuideDoneButton,
          steps: [
            {
              title,
              intro: T.joinCourseInteractiveGuideWelcome,
            },
            {
              element: document.querySelector('.introjs-tabs') as Element,
              title,
              intro: T.joinCourseInteractiveGuideTabs,
            },
            {
              element: document.querySelector('.introjs-search') as Element,
              title,
              intro: T.joinCourseInteractiveGuideSearch,
            },
            {
              element: document.querySelector('.introjs-join') as Element,
              title,
              intro: T.joinCourseInteractiveGuideJoin,
            },
          ],
        })
        .start();
      this.$cookies.set('has-visited-join-course', true, -1);
    }
  }

  get tabNames(): Record<Tab, string> {
    return {
      [Tab.Public]: T.courseTabPublic,
      [Tab.Enrolled]: this.loggedIn
        ? ui.formatString(T.courseTabEnrolled, {
            course_count: this.courses.enrolled.length,
          })
        : T.courseTabEnrolledUnlogged,
      [Tab.Finished]: this.loggedIn
        ? ui.formatString(T.courseTabFinished, {
            course_count: this.courses.finished.length,
          })
        : T.courseTabFinishedUnlogged,
    };
  }

  get filteredCards():
    | types.CourseCardEnrolled[]
    | types.CourseCardPublic[]
    | types.CourseCardFinished[] {
    switch (this.currentSelectedTab) {
      case Tab.Enrolled:
        return this.courses.enrolled.filter(
          (course) =>
            this.searchText === '' ||
            latinize(course.name.toLowerCase()).includes(
              latinize(this.searchText.toLowerCase()),
            ),
        );
      case Tab.Finished:
        return this.courses.finished.filter(
          (course) =>
            this.searchText === '' ||
            latinize(course.name.toLowerCase()).includes(
              latinize(this.searchText.toLowerCase()),
            ),
        );
      default:
        // Only apply level filter to public courses
        return this.courses.public.filter((course) => {
          const matchesText =
            this.searchText === '' ||
            latinize(course.name.toLowerCase()).includes(
              latinize(this.searchText.toLowerCase()),
            );

          const matchesLevel =
            this.levelFilter === Level.All || course.level === this.levelFilter;

          return matchesText && matchesLevel;
        });
    }
  }
}
